import React from 'react';
import { Menu } from 'semantic-ui-react';
import ManagedMenuDropdown from './ManagedMenuDropdown';
import IntExtLinkHandler from './IntExtLinkHandler';


function APIMenu(_ref) {
  var authUser = _ref.authUser,
      loadedMenu = _ref.loadedMenu,
      pathname = _ref.pathname,
      history = _ref.history,
      mobileBreakpoint = _ref.mobileBreakpoint;

  return React.createElement(
    React.Fragment,
    null,
    // is the user authorised to see the menu
    // print it or skip it
    authUser ? React.createElement(
      Menu.Menu,
      null,
      // map and loop the top level items
      loadedMenu && loadedMenu.items && Object.entries(loadedMenu.items).map(function (_ref2, key) {
        var id = _ref2[0],
            menuItem = _ref2[1];
        return (
          // show the menu item normally if there's no access checking
          React.createElement(
            React.Fragment,
            { key: key },
            // does this item have children
            menuItem.children && pathname ? React.createElement(ManagedMenuDropdown, {
              menuItem: menuItem,
              pathname: pathname,
              history: history,
              mobileBreakpoint: mobileBreakpoint
            }) : React.createElement(IntExtLinkHandler, { menuItem: menuItem })
          )
        );
      })
    ) : ''
  );
}

export default APIMenu;